import { SxProps, Theme } from "@mui/material";

export {
  buttonsContainerStyles,
  errorTypographyStyles,
  fieldContainerStyles,
  modalBoxStyles,
  secondaryButtonStyles,
} from "../create-user-form/styles";

const SELECTED_PRIMARY = "rgb(25, 118, 210)";

export const headerTypographyStyles: SxProps<Theme> = (theme) => ({
  color: theme.palette.modalColors.headerColor,
});

export const hintTypographyStyles: SxProps<Theme> = (theme) => ({
  fontFamily: "Red Hat Display",
  color: theme.palette.adminPanel.textColor,
  opacity: 0.75,
  margin: 0,
});

export const successTypographyStyles: SxProps = {
  fontFamily: "Red Hat Display",
  color: "#15803d",
  textAlign: "left",
  margin: 0,
};

export const emptyListTypographyStyles: SxProps<Theme> = (theme) => ({
  fontFamily: "Red Hat Display",
  color: theme.palette.adminPanel.textColor,
  opacity: 0.7,
  textAlign: "center",
  padding: "16px",
});

export const listContainerStyles: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  maxHeight: "40dvh",
  overflowY: "auto",
  border: `1px solid ${theme.palette.adminPanel.borderColor}`,
  borderRadius: "12px",
  padding: "8px",
  backgroundColor: theme.palette.adminPanel.calendarBg,
});

export const listLoadingStyles: SxProps = {
  display: "flex",
  justifyContent: "center",
  padding: "24px",
};

export const contestItemStyles =
  (isSelected: boolean): SxProps<Theme> =>
  (theme) => ({
    cursor: "pointer",
    borderRadius: "10px",
    padding: "10px 12px",
    color: theme.palette.adminPanel.textColor,
    border: isSelected
      ? `1px solid ${SELECTED_PRIMARY}`
      : "1px solid transparent",
    backgroundColor: isSelected
      ? "rgba(25, 118, 210, 0.16)"
      : "transparent",
    "&:hover": {
      backgroundColor: isSelected
        ? "rgba(25, 118, 210, 0.22)"
        : theme.palette.adminPanel.calendarBgHover,
    },
  });

export const contestTitleTypographyStyles: SxProps<Theme> = (theme) => ({
  color: theme.palette.adminPanel.textColor,
});

export const contestMetaTypographyStyles: SxProps<Theme> = (theme) => ({
  fontFamily: "Red Hat Display",
  fontSize: "0.75rem",
  color: theme.palette.adminPanel.textColor,
  opacity: 0.75,
});

export const deleteButtonStyles = {
  height: "40px",
  borderRadius: "20px",
  paddingX: "2rem",
  textTransform: "none",
  background: "rgb(210, 25, 25)",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
    background: "rgba(210, 25, 25, 0.8)",
  },
} as const;
